export { AccessRightsTab } from '@pages/Users/AccessRightsTab/AccessRightsTab.main';
